import { render, staticRenderFns } from "./video_detail.vue?vue&type=template&id=fd0d15d4&scoped=true"
import script from "./video_detail.vue?vue&type=script&lang=js"
export * from "./video_detail.vue?vue&type=script&lang=js"
import style0 from "./video_detail.vue?vue&type=style&index=0&id=fd0d15d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0d15d4",
  null
  
)

export default component.exports